import { EventDrivenStore } from '@core/store';
import constants from './constants';

class EsimStore extends EventDrivenStore {
  constructor() {
    super('esim', {
      countries: [],
      packages: [],
      selectedCountry: null,
      selectedPackage: null,
      countrySearch: '',
      loading: false,
      packagesLoading: false,
      error: null
    }, {
      useLocalStorage: true
    });
  }

  setupEvents() {
    // Countries fetch started
    this.on(constants.EVENTS.ESIM.FETCH_COUNTRIES, () => {
      this.updateState({ loading: true, error: null });
    });

    // Countries fetch success
    this.on(constants.EVENTS.ESIM.FETCH_COUNTRIES_SUCCESS, (countries) => {
      this.updateState({
        countries,
        loading: false,
        error: null
      });
    });

    // Countries fetch error
    this.on(constants.EVENTS.ESIM.FETCH_COUNTRIES_ERROR, (error) => {
      this.updateState({
        loading: false,
        error: 'Impossible de charger la liste des pays'
      });
    });

    // Packages fetch started
    this.on(constants.EVENTS.ESIM.FETCH_PACKAGES, () => {
      this.updateState({ packagesLoading: true, error: null });
    });

    // Packages fetch success
    this.on(constants.EVENTS.ESIM.FETCH_PACKAGES_SUCCESS, (packages) => {
      this.updateState({
        packages,
        packagesLoading: false,
        error: null
      });
    });

    // Packages fetch error
    this.on(constants.EVENTS.ESIM.FETCH_PACKAGES_ERROR, (error) => {
      this.updateState({
        packagesLoading: false,
        error: 'Impossible de charger les forfaits'
      });
    });

    // Select country
    this.on('esim.select_country', (country) => {
      this.updateState({
        selectedCountry: country,
        selectedPackage: null,
        packages: []
      });
    });

    // Select package
    this.on('esim.select_package', (pkg) => {
      this.updateState({ selectedPackage: pkg });
    });

    // Country search
    this.on('esim.country_search', (searchTerm) => {
      this.updateState({ countrySearch: searchTerm });
    });

    // Create order started
    this.on(constants.EVENTS.ESIM.CREATE_ORDER, () => {
      this.updateState({ loading: true, error: null });
    });

    // Create order success
    this.on(constants.EVENTS.ESIM.CREATE_ORDER_SUCCESS, () => {
      this.updateState({
        loading: false,
        selectedCountry: null,
        selectedPackage: null
      });
    });

    // Create order error
    this.on(constants.EVENTS.ESIM.CREATE_ORDER_ERROR, (error) => {
      this.updateState({
        loading: false,
        error: error || 'Erreur lors de la création de la commande'
      });
    });
  }
}

export default EsimStore;
